export default [
    {
        id: 1,
        name_ca: '0 a 10 anys',
        name_en: '0 to 10 years',
        name_es: '0 a 10 años'
    },
    {
        id: 2,
        name_ca: '10 a 25 anys',
        name_en: '10 to 25 years',
        name_es: '10 a 25 años'
    },
    {
        id: 3,
        name_ca: '25 a 50 anys',
        name_en: '25 to 50 years',
        name_es: '25 a 50 años'
    },
    {
        id: 4,
        name_ca: 'Més de 50 anys',
        name_en: 'More than 50 years',
        name_es: 'Más de 50 años'
    }
]


// WEBPACK FOOTER //
// ./src/options/average_ages.js